// extracted by mini-css-extract-plugin
export default {"wrapper":"PieChart_wrapper__pr+5U"};